import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ErrorPopup = ({ isOpen, toggle, message, title }) => (
  <Modal isOpen={isOpen} toggle={toggle} centered>
    <ModalHeader toggle={toggle} className="text-danger">{title}</ModalHeader>
    <ModalBody>
      {message || 'An error occurred. Please try again.'}
    </ModalBody>
    <ModalFooter>
      <Button color="danger" onClick={toggle}>Close</Button>
    </ModalFooter>
  </Modal>
);

export default ErrorPopup;
